import React, { useState, useEffect } from 'react';

const Promised = (props) => {
  const [content, setContent] = useState('');

  useEffect(() => {
    let mounted = true;
    props.promise
      .then(c => { if (mounted) setContent(c.value || c); })
      .catch(() => {});
    return () => { mounted = false; };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return <span>{content}</span>;
};
export { Promised };

export default function stringOrComponent(o, o2){
  if (o === undefined) {
    return null;
  }
  if (typeof(o) === 'string') {
    return o;
  }
  if (o.then != null) {
    return <Promised promise={o} />;
  }
  if (React.isValidElement(o)){
    return o;
  }
  const Component = o.component || o;
  const props = Object.assign({}, o.component ? o : null, o2);
  delete props.component;
  return <Component {...props} />;
};
